var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOneline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 15C13.866 15 17 11.866 17 8C17 4.13401 13.866 1 10 1C6.13401 1 3 4.13401 3 8C3 9.58975 3.52995 11.0557 4.42283 12.2309",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    vectorEffect: "non-scaling-stroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 19.75C15.4142 19.75 15.75 19.4142 15.75 19C15.75 18.5858 15.4142 18.25 15 18.25V19.75ZM11.0964 5.77854C11.2502 5.39396 11.0631 4.95748 10.6785 4.80364C10.294 4.64981 9.85748 4.83687 9.70364 5.22146L11.0964 5.77854ZM5.54856 17.6286L4.8522 17.3501L5.54856 17.6286ZM6.47703 19.75H15V18.25H6.47703V19.75ZM9.70364 5.22146L4.8522 17.3501L6.24491 17.9072L11.0964 5.77854L9.70364 5.22146ZM6.47703 18.25C6.30017 18.25 6.17923 18.0714 6.24491 17.9072L4.8522 17.3501C4.39239 18.4996 5.23897 19.75 6.47703 19.75V18.25Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneline);
export default __webpack_public_path__ + "static/media/oneline.8e98e29e90b0cc49852a7a70df482f7a.svg";
export { ForwardRef as ReactComponent };